<template>
    <!-- <aicc-page :titleShow="false"> -->
        <!-- <ur-area> -->
            <div class="wrap">
                <div class="contents_wrap">
                    <section>
                        <div class="login_wrap step1">
                            <h3>AICC의<br>이름과 접속경로를 설정해주세요.</h3>
                            <div class="form_box">
                                <div class="hbox jc">
                                    <label for="ipt1">이름</label>
                                    <ur-text-field v-model="ccNm" ref="ccNmField" :key="ccNmKey"
                                    placeholder = 'AICC 이름을 입력해주세요.' width="460px"/>
                                    <span :class="pClass_ccNm">{{this.ccNmCnt}}/20</span>
                                </div>
                                <div class="hbox jc">
                                    <label for="ipt2">접속경로</label>
                                    <span class="txt">{{this.path}}</span>
                                    <ur-text-field v-model="ccUrl" ref="ccUrlField" :key="ccUrlKey"
                                    placeholder = '영소문자만 입력해주세요.' width="205px" />
                                    <span :class="pClass_ccUrl">{{this.ccUrlCnt}}/20</span>
                                </div>
                                <div class="pass_check">
                                    <span><em class="checkmark" :class="{active:isActiveCcNm}"></em>컨택센터 이름은 국문, 영문, 숫자, 공백만 사용 가능</span>
                                    <span><em class="checkmark" :class="{active:isActiveCcUrl}"></em>접속경로는 영소문자만 사용 가능</span>
                                    <span><em class="checkmark" :class="{active:isActiveUrlDup}"></em>중복된 접속경로 없음</span>
                                </div>
                                <div class="btn_wrap">
                                    <!-- <button type="button" class="btn btn_color primary btn_l" :disabled="!(isActiveCcNm&&isActiveCcUrl&&isActiveUrlDup)" @click="onClickConfirm()">다음</button> -->
                                    <ur-button solid primary size="large" :disabled="!(isActiveCcNm&&isActiveCcUrl&&isActiveUrlDup)" @click="onClickConfirm()">다음</ur-button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        <!-- </ur-area> -->
    <!-- </aicc-page> -->
</template>
<script>
import BasePage from '~cm/components/BasePage';
// import utils from '~common/js/utils';
import {urDataSet} from 'uidev-component/index.js';
// import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
// import '~assets/css/aicc/common.css';

export default {
    name:'PGE_AIM_00002',
    extends: BasePage,
    components:{},
    data() {
        return {
            aiccInfo:{
                contactCenterNm:'',
                contactCenterUrl:'',
                serviceStartDate:'',
            },
            ccNmCnt:0,
            ccUrlCnt:0,
            isActiveCcNm:false,
            isActiveCcUrl:false,
            isActiveUrlDup:false,
            existCcUrlCnt:0,
            ccUrl:'',
            ccNm:'',
            ccNmKey:0,
            ccUrlKey:0,
        }
    },
    created(){
        this.debouncedGetAnswer = _.debounce(this.getCcUrlCnt, 500);
    },
    mounted(){
        this.$store.state.isGnbMenuShowed = false;
        this.$store.state.lnbShowed = false;
        this.getCcInfo();
    },
    watch:{
        ccNm: function(newCcNm){
            this.isActiveCcNm = false;
            // handler(newValue, oldValue) {
            const regCcNm=/^[a-zA-Z0-9ㄱ-힣][a-zA-Z0-9ㄱ-힣 ]*$/;

            this.ccNmCnt = aiccUtils.getStringByteSize(newCcNm);
            if(this.ccNmCnt > 20){
                // if(oldValue !== '' && oldValue !== null){
                //     this.ccNm = oldValue;
                // }else{
                //     this.ccNm = aiccUtils.substringByByte(newValue, 20);
                //     this.ccNmCnt  = aiccUtils.getStringByteSize(this.ccNm);
                // }
                // this.ccNmKey++;
                // this.$nextTick(() => {
                //     this.$refs['ccNmField'].focus();
                // })
                this.isActiveCcNm = false;
                return;
            }else{
                this.isActiveCcNm = true;
            }
            
            this.isActiveCcNm = regCcNm.test(newCcNm);                
            // }
        },
        ccUrl: function(newCcUrl){
            // handler(newValue, oldValue) {
            this.isActiveCcUrl = false;
            this.isActiveUrlDup = false;
            const regCcUrl=/^[a-z][a-z ]*$/;

            this.ccUrlCnt = aiccUtils.getStringByteSize(newCcUrl);
            if(this.ccUrlCnt > 20){
                // if(oldValue !== '' && oldValue !== null){
                //     this.ccUrl = oldValue;
                // }else{
                //     this.ccUrl = aiccUtils.substringByByte(newValue, 20);
                //     this.ccUrlCnt = aiccUtils.getStringByteSize(this.ccUrl);
                // }
                // this.ccUrlKey++;
                // this.$nextTick(() => {
                //   this.$refs['ccUrlField'].focus();
                // })
                this.isActiveCcUrl = false;
                return;
            }else{
                this.isActiveCcUrl = true;
            }

            this.isActiveCcUrl = regCcUrl.test(newCcUrl);
            this.debouncedGetAnswer();
            // }
        },
    },
    computed:{
        pClass_ccNm(){
            let clazz = [];
            clazz.push('txt_desc');
            if(this.ccNmCnt <= 20) {
                clazz.push('byte');
            } else {
                clazz.push('byte_invalid');
            }
            return clazz;
        },
        pClass_ccUrl(){
            let clazz = [];
            clazz.push('txt_desc');
            if(this.ccUrlCnt <= 20) {
                clazz.push('byte');
            } else {
                clazz.push('byte_invalid');
            }
            return clazz;
        },
        path() {
            return aiccUtils.urlUtil.getProtocolAndDomain() + '/home#/';
        }
    },
    methods:{
        onClickConfirm() {
            console.log('isActiveCcNm', this.isActiveCcNm);
            console.log('isActiveCcUrl', this.isActiveCcUrl);
            console.log('isActiveUrlDup', this.isActiveUrlDup);
            this.onCcInfoSave();
        },
        getCcInfo(){
            http.request(this.contextPageId, 'DTS_AIM_00001' , {})
                .then(res => {
                    this.ccNm = res.data.aiccInfo.contactCenterNm;
                    this.ccUrl = res.data.aiccInfo.contactCenterUrl;
                })
                .catch(error => {

                })
        },
        getCcUrlCnt() {
            this.aiccInfo.contactCenterUrl = this.ccUrl;
            http.request(this.contextPageId, 'DTS_AIM_00010', {
                data:{
                        aiccInfo:this.aiccInfo,
                    }
            }).then(res => {
                if(res.data.urlCnt > 0){
                    this.isActiveUrlDup = false;
                }else{
                    this.isActiveUrlDup = true;
                }
            }).catch(error => {
            })
        },
        onCcInfoSave(){
            this.aiccInfo.contactCenterNm = this.ccNm;
            this.aiccInfo.contactCenterUrl = this.ccUrl;

            http.request(this.$options.name, 'DTS_AIM_00005', {
                data:{
                    aiccInfo:this.aiccInfo,
                }
            }).then((response) => {
                console.log(JSON.stringify(response.data));
                if (response.data.reply.code !== "0000") {
                    utils.messageBox('error', response.data.reply.korMsg);
                } else {              
                    window.location.href=this.aiccInfo.contactCenterUrl;
                }
            }).catch((error) => {
                console.warn(error);
            });
        },
    },
}
</script>
<style scoped>

.login_wrap .form_box .byte_invalid{margin-left: 17px; color: #FF5858; font-size: 14px; white-space: nowrap;}

</style>